import { render, staticRenderFns } from "./InnerCardInfo.vue?vue&type=template&id=2c86be8e&scoped=true&"
import script from "./InnerCardInfo.vue?vue&type=script&lang=js&"
export * from "./InnerCardInfo.vue?vue&type=script&lang=js&"
import style0 from "./InnerCardInfo.vue?vue&type=style&index=0&id=2c86be8e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c86be8e",
  null
  
)

export default component.exports